const getRequiredMessage = (required: string | boolean | undefined | null) => {
  if (required) {
    // Check if required is a string
    if (typeof required === "string") {
      return required;
    }

    return "This field is required.";
  }

  return false;
};

export default getRequiredMessage;
